import cache from '@/utils/cache';

/**
 * 获取属性值
 * @param { Object } state 存储对象
 * @param { String } field 存储字段
 * @returns 字段值
 */
export function getAttributeValue(state, field) {
    // 判断pageName是否存在,不存在则重新赋值
    if (!state[field]) {
        state[field] = cache.get(field);
    }

    return state[field];
}

/**
 * 设定属性值
 * @param { Object } state 存储对象
 * @param { String } field 存储字段
 * @param { String } value 字段值
 */
export function setAttributeValue(state, field, value) {
    state[field] = value;
    // 同步更新session
    cache.set(field, value);
}

/**
 * 删除属性值
 * @param { String } field 存储字段
 */
export function clearAttributeValue(field) {
    // 删除session
    cache.remove(field);
}


// WEBPACK FOOTER //
// ./src/store/modules/utils.js